import React, { Component } from "react";
import { isValidArray } from "../../helper";
import { get, isFunction, isNull } from "lodash";
import PropTypes from "prop-types";
import { filterNames } from "./filter.selector";
import { getLocalstorage, transformProjectListPayload } from "../../helper";
import { Modal, Button, Image, Form } from "react-bootstrap";
import request from "../../services/requestService";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import QuickFilterIcon from "../../assets/search_icon.png";
import CrossIcon from "../../assets/Vector 441.svg";
import { getProjectList } from "../../services/apiServices";
class ProjectQuickFilter extends Component {
  isDataLoaded = false;
  state = {
    search: {},
    selectedFilters: {},
    sortedListingArr: [],
    quickfilterdata: ["Monitoring Flag"],
    selectall: false,
    MonitoringFlag: [],
    ProjectStatus: [],
    ProjectStage: [],
    ProjectSponsoringMinistry: [],
    ProjectLocation: [],
    ImplementationMode: [],
    ProjectZone: [],
    model_open: false,
    quickfilterdatanew: ["Monitoring Flag"],
    selectalltext: true,
    StaticCheckboxData: [],
    selectedFilters: [],
    propsCheckedData: [],
    searchedtext: "",
    projectFlagsFilterdata: [],
    projectTagsFilterdata: [],
    projectStageFilterdata: [],
    sponsoringMinistryFilterdata: [],
    projectLocationFilterdata: [],
    projectImplementationModeFilterdata: [],
    projectZonefilterdata: [],
    staticfilterdata: [],
    static_payload: {
      offset: 0,
      limit: 1,
      groupCategory: "CENTRAL",
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    }
  };
  handleFilterSelection = filter => {
    const updatedFilters = [...this.state.StaticCheckboxData];

    if (updatedFilters.includes(filter)) {
      updatedFilters.splice(updatedFilters.indexOf(filter), 1);
    } else {
      updatedFilters.push(filter);
    }

    this.setState({ StaticCheckboxData: updatedFilters });
    this.props.onFilterChange(updatedFilters);
  };
  componentDidMount = async () => {
    const response = await request(
      getProjectList(transformProjectListPayload(this.state.static_payload))
    );
    this.setState({ staticfilterdata: response.data.data.filters });
    //console.log(response.data.data.filters.projectLocation.values)
  };
  // componentDidMount() {
  //   const { filterData,checkedData,staticFilterData} = this.props;
  //   const checkedData1 = checkedData.map((obj) => obj.displayName);

  //   console.log(staticFilterData.projectFlags.values)
  //         this.setState({
  //     filtersSortedData: filterData,
  //     propsCheckedData:checkedData1
  //   });
  // }

  getFilteredData = (sortedListingArr, name) => {
    this.setState(prevState => {
      return {
        sortedListingArr: {
          ...prevState.sortedListingArr,
          [name]: sortedListingArr
        },
        isSearching: get(sortedListingArr, "isSearching")
      };
    });
  };

  handleSubmit = () => {
    const {
      onChange1,
      onChange2,
      onChange3,
      onChange4,
      onChange5,
      onChange6,
      onChange7
    } = this.props;
    localStorage.setItem("ClearAll", JSON.stringify(false));
    this.state.quickfilterdatanew.map(e => {
      if (e == "Monitoring Flag") {
        var element = this.state.MonitoringFlag.map(item => {
          return item;
        });
        isFunction(onChange1) && onChange1(element, "projectFlags");
        this.setState({ model_open: false });
        //this.props.onFilterChange(this.state.MonitoringFlag,"projectFlags");
      } else if (e == "Project Status") {
        var element = this.state.ProjectStatus.map(item => {
          return item;
        });
        isFunction(onChange2) && onChange2(element, "projectTags");
        //this.props.onFilterChange( this.state.ProjectStatus,"projectTags");
      } else if (e == "Project Stage") {
        var element = this.state.ProjectStage.map(item => {
          return item;
        });
        isFunction(onChange3) && onChange3(element, "projectStage");
      } else if (e == "Project Sponsoring Ministry") {
        var element = this.state.ProjectSponsoringMinistry.map(item => {
          return item;
        });

        isFunction(onChange4) && onChange4(element, "sponsoringMinistry");
      } else if (e == "Project Location") {
        //console.log(element)
        var element = this.state.ProjectLocation.map(item => {
          return item;
        });
        isFunction(onChange5) && onChange5(element, "projectLocation");
      } else if (e == "Implementation Mode") {
        var element = this.state.ImplementationMode.map(item => {
          return item;
        });
        isFunction(onChange6) &&
          onChange6(element, "projectImplementationMode");
      } else if (e == "Zone") {
        var element = this.state.ProjectZone.map(item => {
          return item;
        });
        isFunction(onChange7) && onChange7(element, "projectZones");
      } else {
        // Handle other conditions
      }
    });

    const combinedFilters = this.state.ProjectStage.map(flag => ({
      ...flag,
      filterName: "projectStage"
    }));
    combinedFilters.push(
      ...this.state.MonitoringFlag.map(filter => ({
        ...filter,
        filterName: "projectFlags"
      }))
    );
    combinedFilters.push(
      ...this.state.ProjectLocation.map(filter => ({
        ...filter,
        filterName: "projectLocation"
      }))
    );
    combinedFilters.push(
      ...this.state.ProjectStatus.map(filter => ({
        ...filter,
        filterName: "projectTags"
      }))
    );
    combinedFilters.push(
      ...this.state.ProjectSponsoringMinistry.map(filter => ({
        ...filter,
        filterName: "sponsoringMinistry"
      }))
    );
    combinedFilters.push(
      ...this.state.ImplementationMode.map(filter => ({
        ...filter,
        filterName: "projectImplementationMode"
      }))
    );
    combinedFilters.push(
      ...this.state.ProjectZone.map(filter => ({
        ...filter,
        filterName: "projectZones"
      }))
    );
    this.setState({ selectedFilters: combinedFilters }, () => {
      this.props.onFilterChange(this.state.selectedFilters);
    });
  };
  handleOpen = () => {
    this.setState({
      model_open: true,
      MonitoringFlag: [],
      ProjectStage: [],
      ProjectStatus: [],
      ProjectSponsoringMinistry: [],
      ProjectLocation: [],
      ProjectZone: [],
      quickfilterdata: ["Monitoring Flag"],
      ImplementationMode: [],
      searchedtext: "",
      selectalltext: true,
      selectall: false
    });
    const { checkedData, Projectstageandstatusdisplay } = this.props;
    let usersWithoutTim = this.state.staticfilterdata.projectTags.values.filter(
      user => user.key !== "NO_COMPLETION_STAGE"
      // && user.key !== "NO_IMPLEMENTATION"
    );
    this.setState({
      projectFlagsFilterdata: this.state.staticfilterdata.projectFlags.values,
      projectTagsFilterdata: usersWithoutTim,
      projectStageFilterdata: this.state.staticfilterdata.projectStage.values,
      sponsoringMinistryFilterdata: this.state.staticfilterdata
        .sponsoringMinistry.values,
      projectLocationFilterdata: this.state.staticfilterdata.projectLocation
        .values,
      projectImplementationModeFilterdata: this.state.staticfilterdata
        .projectImplementationMode.values,
      projectZonefilterdata: this.state.staticfilterdata.projectZones.values
    });
    //console.log(staticFilterData.projectFlags.values)
    const checkedData1 = checkedData.map(obj => obj.displayName);
    this.setState({
      propsCheckedData: checkedData1
    });
    const filteredArray1 = checkedData.filter(
      item => item.filterName === "projectFlags"
    );
    const filteredArray2 = checkedData.filter(
      item => item.filterName === "projectTags"
    );
    const filteredArray3 = checkedData.filter(
      item => item.filterName === "projectStage"
    );
    const filteredArray4 = checkedData.filter(
      item => item.filterName === "sponsoringMinistry"
    );
    const filteredArray5 = checkedData.filter(
      item => item.filterName === "projectLocation"
    );
    const filteredArray6 = checkedData.filter(
      item => item.filterName === "projectImplementationMode"
    );
    const filteredArray8 = checkedData.filter(
      item => item.filterName === "projectZones"
    );
    if (Projectstageandstatusdisplay == true) {
      // const targetNames = [
      //   "UNDER CONSTRUCTION",
      //   "PROVISIONALLY COMMISSIONED",
      //   "PHYSICALLY COMPLETED/CC UNDER ISSUE",
      //   "NOT COMMISSIONED"
      // ];
      const targetNames1 = ["UNDER VERIFICATION", "VERIFIED"];
      // const filteredArray=usersWithoutTim.filter(item => {
      //   return targetNames.includes(item.displayName);
      // });
      const filteredArray1 = this.state.staticfilterdata.projectStage.values.filter(
        item => {
          return targetNames1.includes(item.displayName);
        }
      );
      this.setState({
        //projectTagsFilterdata:filteredArray,
        projectStageFilterdata: filteredArray1
      });
    }
    const { filterData, filtersValue } = this.props;
    const filtersKeysArr = Object.keys(filterData || {});

    /* //Count Update For Monitoring Flag
    for (const flag of staticFilterData.projectFlags.values) {
      const otherFlag = filterData.projectFlags.values.find(f => f.key === flag.key);
      flag.count = otherFlag ? otherFlag.count : 0;
    }
     //Count Update For Project Status
     for (const flag of staticFilterData.projectTags.values) {
      const otherFlag = filterData.projectTags.values.find(f => f.key === flag.key);
      flag.count = otherFlag ? otherFlag.count : 0;
    }
     //Count Update For Project Stage
     for (const flag of staticFilterData.projectStage.values) {
      const otherFlag = filterData.projectStage.values.find(f => f.key === flag.key);
      flag.count = otherFlag ? otherFlag.count : 0;
    }
    //Count Update For Sponsory Ministry
    for (const flag of staticFilterData.sponsoringMinistry.values) {
      const otherFlag = filterData.sponsoringMinistry.values.find(f => f.key === flag.key);
      flag.count = otherFlag ? otherFlag.count : 0;
    }
    //Count Update For Project Location
    for (const flag of staticFilterData.projectLocation.values) {
      const otherFlag = filterData.projectLocation.values.find(f => f.key === flag.key);
      flag.count = otherFlag ? otherFlag.count : 0;
    }
    //Count Update For Implementation Mode
    for (const flag of staticFilterData.projectImplementationMode.values) {
      const otherFlag = filterData.projectImplementationMode.values.find(f => f.key === flag.key);
      flag.count = otherFlag ? otherFlag.count : 0;
    }
    */
    const checkedFilters1 = new Set();
    const checkedFilters2 = new Set();
    const checkedFilters3 = new Set();
    const checkedFilters4 = new Set();
    const checkedFilters5 = new Set();
    const checkedFilters6 = new Set();
    const checkedFilters7 = new Set();
    filtersKeysArr.map(filterName => {
      const currentFilter = filterData[filterName];

      if (currentFilter && currentFilter.values) {
        currentFilter.values = this.placeCheckedFiltersOnTop(
          currentFilter.values
        );
      }

      const filterCurrentValue = filtersValue[filterName];
      const _filterName = filterNames[get(currentFilter, "displayName")];
      const searchedFilterList = this.getSearchedFilters(
        get(currentFilter, "values"),
        this.getStateFilterVal(_filterName)
      );

      if (get(currentFilter, "displayName", "NA") === "Monitoring Flag") {
        searchedFilterList.map(filter => {
          if (get(filter, "checked", "NA") === true) {
            checkedFilters1.add(filter);
            checkedFilters7.add(filter.displayName);
          }
        });
      } else if (get(currentFilter, "displayName", "NA") === "Project Status") {
        searchedFilterList.map(filter => {
          if (get(filter, "checked", "NA") === true) {
            checkedFilters2.add(filter);
            checkedFilters7.add(filter.displayName);
          }
        });
      } else if (get(currentFilter, "displayName", "NA") === "Project Stage") {
        searchedFilterList.map(filter => {
          if (get(filter, "checked", "NA") === true) {
            checkedFilters3.add(filter);
            checkedFilters7.add(filter.displayName);
          }
        });
      } else if (
        get(currentFilter, "displayName", "NA") ===
        "Project Sponsoring Ministry"
      ) {
        searchedFilterList.map(filter => {
          if (get(filter, "checked", "NA") === true) {
            checkedFilters4.add(filter);
            checkedFilters7.add(filter.displayName);
          }
        });
      } else if (
        get(currentFilter, "displayName", "NA") === "Project Location"
      ) {
      } else if (
        get(currentFilter, "displayName", "NA") === "Implementation Mode"
      ) {
        searchedFilterList.map(filter => {
          if (get(filter, "checked", "NA") === true) {
            checkedFilters6.add(filter);
            checkedFilters7.add(filter.displayName);
          }
        });
      } else {
      }

      this.setState({ MonitoringFlag: filteredArray1 }, () => {
        // if(this.state.MonitoringFlag.length!=0){
        //   const updatedFilters = [...this.state.selectedFilters];
        //     updatedFilters.push(...Array.from(checkedFilters1));
        //   this.setState({ selectedFilters: updatedFilters },()=>{
        //     //console.log(this.state.selectedFilters)
        //   });
        // }

        if (searchedFilterList.length == this.state.MonitoringFlag.length) {
          if (
            searchedFilterList.length == 0 &&
            this.state.MonitoringFlag.length == 0
          ) {
          } else {
            this.setState({ selectall: true });
          }
        }
      });
      this.setState({ ProjectStage: filteredArray3 }, () => {
        if (searchedFilterList.length == this.state.ProjectStage.length) {
          //this.setState({selectall:true})
        }
      });
      this.setState({ ProjectStatus: filteredArray2 }, () => {
        if (searchedFilterList.length == this.state.ProjectStatus.length) {
          // this.setState({selectall:true})
        }
      });
      this.setState({ ProjectSponsoringMinistry: filteredArray4 }, () => {
        if (
          searchedFilterList.length ==
          this.state.ProjectSponsoringMinistry.length
        ) {
          //this.setState({selectall:true})
        }
      });
      this.setState({ ProjectLocation: filteredArray5 }, () => {
        filteredArray5.map(filter => {
          checkedFilters7.add(filter.displayName);
        });
        if (searchedFilterList.length == this.state.ProjectLocation.length) {
          //this.setState({selectall:true})
        }
      });
      this.setState({ ImplementationMode: filteredArray6 }, () => {
        if (searchedFilterList.length == this.state.ImplementationMode.length) {
          //this.setState({selectall:true})
        }
      });
      this.setState({ ProjectZone: filteredArray8 }, () => {
        if (searchedFilterList.length == this.state.ProjectZone.length) {
          //this.setState({selectall:true})
        }
      });
      this.setState({ StaticCheckboxData: Array.from(checkedFilters7) });
      // const combinedFilters = this.state.MonitoringFlag.map(flag => ({ ...flag }));
      // combinedFilters.push(...Array.from(checkedFilters3).map(filter => ({ ...filter })));
      // combinedFilters.push(...Array.from(checkedFilters2).map(filter => ({ ...filter })));
      // combinedFilters.push(...Array.from(checkedFilters4).map(filter => ({ ...filter })));
      // combinedFilters.push(...Array.from(checkedFilters5).map(filter => ({ ...filter})));
      // combinedFilters.push(...Array.from(checkedFilters6).map(filter => ({ ...filter})));
      // this.setState({ selectedFilters: combinedFilters },()=>{
      //   //console.log(this.state.selectedFilters)
      // });
    });
  };
  handleClose = () => {
    this.setState({ model_open: false });
  };
  handlecheckboxcount(e, displayName, filter, searchedFilterList) {
    if (e.target.checked) {
      //filter.checked=true
      const newItems1 = [...this.state.StaticCheckboxData];
      newItems1.push(filter.displayName);
      this.setState({ StaticCheckboxData: newItems1, selectall: false });
      if (displayName == "Monitoring Flag") {
        this.setState(
          { MonitoringFlag: this.state.MonitoringFlag.concat([filter]) },
          () => {
            if (
              this.state.projectFlagsFilterdata.length ==
              this.state.MonitoringFlag.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (displayName == "Project Status") {
        this.setState(
          { ProjectStatus: this.state.ProjectStatus.concat([filter]) },
          () => {
            if (
              this.state.projectTagsFilterdata.length ==
              this.state.ProjectStatus.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (displayName == "Project Stage") {
        this.setState(
          { ProjectStage: this.state.ProjectStage.concat([filter]) },
          () => {
            if (
              this.state.projectStageFilterdata.length ==
              this.state.ProjectStage.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (displayName == "Project Sponsoring Ministry") {
        this.setState(
          {
            ProjectSponsoringMinistry: this.state.ProjectSponsoringMinistry.concat(
              [filter]
            )
          },
          () => {
            if (
              this.state.sponsoringMinistryFilterdata.length ==
              this.state.ProjectSponsoringMinistry.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (displayName == "Project Location") {
        this.setState(
          { ProjectLocation: this.state.ProjectLocation.concat([filter]) },
          () => {
            if (
              this.state.projectLocationFilterdata.length ==
              this.state.ProjectLocation.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (displayName == "Implementation Mode") {
        //console.log(filter);
        //console.log(displayName);
        this.setState(
          {
            ImplementationMode: this.state.ImplementationMode.concat([filter])
          },
          () => {
            if (
              this.state.projectImplementationModeFilterdata.length ==
              this.state.ImplementationMode.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (displayName == "Zone") {
        this.setState(
          { ProjectZone: this.state.ProjectZone.concat([filter]) },
          () => {
            //console.log(this.state.ProjectZone);
            if (
              this.state.projectZonefilterdata.length ==
              this.state.ProjectZone.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
    } else {
      this.setState({
        selectall: false,
        StaticCheckboxData: this.state.StaticCheckboxData.filter(function(val) {
          return val !== filter.displayName;
        }),
        propsCheckedData: this.state.propsCheckedData.filter(function(val) {
          return val !== filter.displayName;
        })
      });
      //filter.checked=false
      if (displayName == "Monitoring Flag") {
        this.setState({
          MonitoringFlag: this.state.MonitoringFlag.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (displayName == "Project Status") {
        this.setState({
          ProjectStatus: this.state.ProjectStatus.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (displayName == "Project Stage") {
        this.setState({
          ProjectStage: this.state.ProjectStage.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (displayName == "Project Sponsoring Ministry") {
        this.setState({
          ProjectSponsoringMinistry: this.state.ProjectSponsoringMinistry.filter(
            function(val) {
              return val.displayName !== filter.displayName;
            }
          )
        });
      }
      if (displayName == "Project Location") {
        this.setState({
          ProjectLocation: this.state.ProjectLocation.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (displayName == "Implementation Mode") {
        this.setState({
          ImplementationMode: this.state.ImplementationMode.filter(function(
            val
          ) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (displayName == "Zone") {
        this.setState({
          ProjectZone: this.state.ProjectZone.filter(
            function(val) {
              return val.displayName !== filter.displayName;
            },
            () => {
              //console.log(this.state.ProjectZone);
            }
          )
        });
      }
    }
  }

  handleSelectAll(e, searchedFilterList, displayname) {
    if (e.target.checked) {
      //var newArr = searchedFilterList.map((item) => item.displayName);
      if (this.state.quickfilterdata.includes("Monitoring Flag")) {
        var allelement = this.state.projectFlagsFilterdata.map(item => {
          item.checked = true;
          return item;
        });
        var allelementdisplayname = this.state.projectFlagsFilterdata.map(
          item => {
            return item.displayName;
          }
        );
      } else if (this.state.quickfilterdata.includes("Project Status")) {
        var allelement = this.state.projectTagsFilterdata.map(item => {
          item.checked = true;
          return item;
        });
        var allelementdisplayname = this.state.projectTagsFilterdata.map(
          item => {
            return item.displayName;
          }
        );
      } else if (this.state.quickfilterdata.includes("Project Stage")) {
        var allelement = this.state.projectStageFilterdata.map(item => {
          item.checked = true;
          return item;
        });
        var allelementdisplayname = this.state.projectStageFilterdata.map(
          item => {
            return item.displayName;
          }
        );
      } else if (
        this.state.quickfilterdata.includes("Project Sponsoring Ministry")
      ) {
        var allelement = this.state.sponsoringMinistryFilterdata.map(item => {
          item.checked = true;
          return item;
        });
        var allelementdisplayname = this.state.sponsoringMinistryFilterdata.map(
          item => {
            return item.displayName;
          }
        );
      } else if (this.state.quickfilterdata.includes("Project Location")) {
        var allelement = this.state.projectLocationFilterdata.map(item => {
          item.checked = true;
          return item;
        });
        var allelementdisplayname = this.state.projectLocationFilterdata.map(
          item => {
            return item.displayName;
          }
        );
      } else if (this.state.quickfilterdata.includes("Implementation Mode")) {
        var allelement = this.state.projectImplementationModeFilterdata.map(
          item => {
            item.checked = true;
            return item;
          }
        );
        var allelementdisplayname = this.state.projectImplementationModeFilterdata.map(
          item => {
            return item.displayName;
          }
        );
      } else if (this.state.quickfilterdata.includes("Zone")) {
        var allelement = this.state.projectZonefilterdata.map(item => {
          item.checked = true;
          return item;
        });
        var allelementdisplayname = this.state.projectZonefilterdata.map(
          item => {
            return item.displayName;
          }
        );
      }
      const newItems1 = [...this.state.StaticCheckboxData];
      newItems1.push(...allelementdisplayname);

      this.setState({ StaticCheckboxData: newItems1 }, () => {
        //console.log(this.state.StaticCheckboxData);
      });
      // var filters = searchedFilterList.map((item) => {
      //   return item;
      // });
      // const updatedFilters = [...this.state.selectedFilters];
      // if (updatedFilters.includes(filters)) {
      //   updatedFilters.splice(updatedFilters.indexOf(filters), 1);
      // } else {
      //   updatedFilters.push(...filters);
      // }

      //this.setState({ selectedFilters: updatedFilters });
      // this.props.onFilterChange(updatedFilters);
      if (displayname == "Monitoring Flag") {
        this.setState({ MonitoringFlag: allelement }, () => {
          //console.log(this.state.MonitoringFlag)
        });
      }
      if (displayname == "Project Status") {
        let usersWithoutTim = allelement.filter(
          user => user.key !== "NO_COMPLETION_STAGE"
          //  &&
          //   user.key !== "NO_IMPLEMENTATION"
        );
        //console.log(usersWithoutTim)
        this.setState({ ProjectStatus: usersWithoutTim }, () => {});
      }
      if (displayname == "Project Stage") {
        this.setState({ ProjectStage: allelement }, () => {
          // console.log(this.state.ProjectStatus)
        });
      }
      if (displayname == "Project Sponsoring Ministry") {
        this.setState({ ProjectSponsoringMinistry: allelement }, () => {
          // console.log(this.state.ProjectStatus)
        });
      }
      if (displayname == "Project Location") {
        this.setState({ ProjectLocation: allelement }, () => {
          // console.log(this.state.ProjectStatus)
        });
      }
      if (displayname == "Implementation Mode") {
        this.setState({ ImplementationMode: allelement }, () => {
          // console.log(this.state.ProjectStatus)
        });
      }
      this.setState({ selectall: true });
      if (displayname == "Zone") {
        this.setState({ ProjectZone: allelement }, () => {
          // console.log(this.state.ProjectStatus)
        });
        this.setState({ selectall: true });
      }
    } else {
      this.setState({ selectall: false, propsCheckedData: [] });
      if (displayname == "Monitoring Flag") {
        const secondArrayKeys = new Set(
          this.state.MonitoringFlag.map(obj => obj.displayName)
        );
        const updatedFirstArray = this.state.StaticCheckboxData.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          StaticCheckboxData: updatedFirstArray,
          MonitoringFlag: []
        });
      }
      if (displayname == "Project Status") {
        const secondArrayKeys = new Set(
          this.state.ProjectStatus.map(obj => obj.displayName)
        );
        const updatedFirstArray = this.state.StaticCheckboxData.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          StaticCheckboxData: updatedFirstArray,
          ProjectStatus: []
        });
      }
      if (displayname == "Project Stage") {
        const secondArrayKeys = new Set(
          this.state.ProjectStage.map(obj => obj.displayName)
        );
        const updatedFirstArray = this.state.StaticCheckboxData.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          StaticCheckboxData: updatedFirstArray,
          ProjectStage: []
        });
      }
      if (displayname == "Project Sponsoring Ministry") {
        const secondArrayKeys = new Set(
          this.state.ProjectSponsoringMinistry.map(obj => obj.displayName)
        );
        const updatedFirstArray = this.state.StaticCheckboxData.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          StaticCheckboxData: updatedFirstArray,
          ProjectSponsoringMinistry: []
        });
      }
      if (displayname == "Project Location") {
        const secondArrayKeys = new Set(
          this.state.ProjectLocation.map(obj => obj.displayName)
        );
        const updatedFirstArray = this.state.StaticCheckboxData.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          StaticCheckboxData: updatedFirstArray,
          ProjectLocation: []
        });
      }
      if (displayname == "Implementation Mode") {
        const secondArrayKeys = new Set(
          this.state.ImplementationMode.map(obj => obj.displayName)
        );
        const updatedFirstArray = this.state.StaticCheckboxData.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          StaticCheckboxData: updatedFirstArray,
          ImplementationMode: []
        });
      }
      if (displayname == "Zone") {
        const secondArrayKeys = new Set(
          this.state.ProjectZone.map(obj => obj.displayName)
        );
        const updatedFirstArray = this.state.StaticCheckboxData.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          StaticCheckboxData: updatedFirstArray,
          ProjectZone: []
        });
      }
    }
  }

  getFilterBySearch = (search, filterName) => {
    const { onChange } = this.props;
    isFunction(onChange) && onChange(search.searchedText, filterName);
  };

  getSearchedFilters = (filterList = [], searchText = "") => {
    //console.log(filterList)
    return filterList.filter(item => {
      if (searchText === "") return true;
      else {
        const regex = new RegExp(searchText, "ig");
        return regex.test(item.displayName);
      }
    });
  };
  handleCross = searchedFilterList => {
    this.setState({ searchedtext: "", selectall: false });
    const { Projectstageandstatusdisplay } = this.props;
    if (this.state.quickfilterdata.includes("Monitoring Flag")) {
      if (searchedFilterList.length == this.state.MonitoringFlag.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        projectFlagsFilterdata: this.state.staticfilterdata.projectFlags.values,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Status")) {
      let usersWithoutTim = this.state.staticfilterdata.projectTags.values.filter(
        user => user.key !== "NO_COMPLETION_STAGE"
        // && user.key !== "NO_IMPLEMENTATION"
      );
      if (this.state.ProjectStatus.length >= 7) {
        this.setState({ selectall: true });
      }
      this.setState({
        projectTagsFilterdata: usersWithoutTim,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Stage")) {
      if (Projectstageandstatusdisplay) {
        const targetNames = ["UNDER VERIFICATION", "VERIFIED"];
        const filteredArray = this.state.staticfilterdata.projectStage.values.filter(
          item => {
            return targetNames.includes(item.displayName);
          }
        );
        this.setState(
          { projectStageFilterdata: filteredArray, selectalltext: true },
          () => {
            if (
              targetNames.length == this.state.projectStageFilterdata.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      } else {
        if (searchedFilterList.length == this.state.ProjectStage.length) {
          this.setState({ selectall: true });
        }
        this.setState({
          projectStageFilterdata: this.state.staticfilterdata.projectStage
            .values,
          selectalltext: true
        });
      }
    } else if (
      this.state.quickfilterdata.includes("Project Sponsoring Ministry")
    ) {
      if (
        searchedFilterList.length == this.state.ProjectSponsoringMinistry.length
      ) {
        this.setState({ selectall: true });
      }
      this.setState({
        sponsoringMinistryFilterdata: this.state.staticfilterdata
          .sponsoringMinistry.values,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Location")) {
      if (searchedFilterList.length == this.state.ProjectLocation.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        projectLocationFilterdata: this.state.staticfilterdata.projectLocation
          .values,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Implementation Mode")) {
      if (searchedFilterList.length == this.state.ImplementationMode.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        projectImplementationModeFilterdata: this.state.staticfilterdata
          .projectImplementationMode.values,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Zone")) {
      if (searchedFilterList.length == this.state.ProjectZone.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        projectZonefilterdata: this.state.staticfilterdata.projectZones.values,
        selectalltext: true
      });
    } else {
    }
  };

  searchDocument = (e, displayName, searchedFilterList) => {
    //console.log(filterName)
    const { Projectstageandstatusdisplay } = this.props;
    const searchAndFilter = searchText => {
      return searchedFilterList.filter(item => {
        // Search within both 'key' and 'displayName' fields
        const lowerCaseSearchText = searchText.toLowerCase();
        const itemKeyLower = item.key.toLowerCase();
        const itemDisplayNameLower = item.displayName.toLowerCase();

        return (
          itemKeyLower.includes(lowerCaseSearchText) ||
          itemDisplayNameLower.includes(lowerCaseSearchText)
        );
      });
    };
    this.setState({ searchedtext: e.target.value });
    // const targetNames = [
    //   "UNDER CONSTRUCTION",
    //   "PROVISIONALLY COMMISSIONED",
    //   "PHYSICALLY COMPLETED/CC UNDER ISSUE",
    //   "NOT COMMISSIONED"
    // ];

    const filteredArray = searchAndFilter(e.target.value.trim());
    // const filteredArraynew=filteredArray.filter(item => {
    //   return targetNames.includes(item.displayName);
    // });
    // console.log(filteredArray)

    if (displayName == "Monitoring Flag") {
      this.setState({ projectFlagsFilterdata: filteredArray }, () => {
        //console.log(this.state.MonitoringFlag)
        if (this.state.projectFlagsFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Project Status") {
      if (Projectstageandstatusdisplay) {
        this.setState({ projectTagsFilterdata: filteredArray }, () => {
          if (this.state.projectTagsFilterdata.length == 0) {
            this.setState({ selectalltext: false });
          } else {
            this.setState({ selectalltext: true });
          }
        });
        // this.setState({projectTagsFilterdata:filteredArraynew},()=>{
        //   if(this.state.projectTagsFilterdata.length==0){
        //     this.setState({selectalltext:false})
        //   }
        //   else{
        //     this.setState({selectalltext:true})
        //   }
        // })
      } else {
        this.setState({ projectTagsFilterdata: filteredArray }, () => {
          if (this.state.projectTagsFilterdata.length == 0) {
            this.setState({ selectalltext: false });
          } else {
            this.setState({ selectalltext: true });
          }
        });
      }
    } else if (displayName == "Project Stage") {
      this.setState({ projectStageFilterdata: filteredArray }, () => {
        if (this.state.projectStageFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Project Sponsoring Ministry") {
      this.setState({ sponsoringMinistryFilterdata: filteredArray }, () => {
        if (this.state.sponsoringMinistryFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Project Location") {
      this.setState({ projectLocationFilterdata: filteredArray }, () => {
        if (this.state.projectLocationFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Implementation Mode") {
      this.setState(
        { projectImplementationModeFilterdata: filteredArray },
        () => {
          if (this.state.projectImplementationModeFilterdata.length == 0) {
            this.setState({ selectalltext: false });
          } else {
            this.setState({ selectalltext: true });
          }
        }
      );
    } else if (displayName == "Zone") {
      this.setState({ projectZonefilterdata: filteredArray }, () => {
        if (this.state.projectZonefilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    }
    //console.log(filteredArray);  // This will output the filtered array
    //   this.setState({
    //     [filterNames[filterName]]: e.target.value.trim(),
    //     searchedtext:e.target.value.trim()
    //   });
    // var allelementdisplayname = searchedFilterList.map((item) => {
    //     return item.displayName;
    //   });
    //   const matches = searchedFilterList.filter(item => {
    //     return item.displayName.toLowerCase().includes(e.target.value.trim().toLowerCase());
    //   });

    //   // Output the matching items

    //   console.log(matches)
    //   if(matches.length==0 && e.target.value.trim()!=" "){
    //     this.setState({selectalltext:false})

    //   }
    //   else{
    //     this.setState({selectalltext:true})
    //   }
  };
  handleFiltertext = (e, displayname, searchedFilterList, values) => {
    const { Projectstageandstatusdisplay } = this.props;
    const newItems = [...this.state.quickfilterdata];
    newItems[0] = displayname;
    this.setState({ quickfilterdata: newItems, selectall: false }, () => {
      //console.log(this.state.quickfilterdata)
    });
    const newItems1 = [...this.state.quickfilterdatanew];
    newItems1.push(displayname);
    this.setState({ quickfilterdatanew: newItems1, searchedtext: "" });

    if (this.state.quickfilterdata.includes("Monitoring Flag")) {
      this.setState({
        projectFlagsFilterdata: this.state.staticfilterdata.projectFlags.values,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Status")) {
      let usersWithoutTim = this.state.staticfilterdata.projectTags.values.filter(
        user => user.key !== "NO_COMPLETION_STAGE"
        // && user.key !== "NO_IMPLEMENTATION"
      );
      if (Projectstageandstatusdisplay) {
        this.setState({
          projectTagsFilterdata: usersWithoutTim,
          selectalltext: true
        });
        //Below Code Commented for Client
        // const targetNames = [
        //   "UNDER CONSTRUCTION",
        //   "PROVISIONALLY COMMISSIONED",
        //   "PHYSICALLY COMPLETED/CC UNDER ISSUE",
        //   "NOT COMMISSIONED"
        // ]
        // const projectstatustargetNamesfilteredArray =  usersWithoutTim.filter(item => {
        //   return targetNames.includes(item.displayName);
        // });
        // this.setState({projectTagsFilterdata:projectstatustargetNamesfilteredArray,selectalltext:true})
      } else {
        this.setState({
          projectTagsFilterdata: usersWithoutTim,
          selectalltext: true
        });
      }
    } else if (this.state.quickfilterdata.includes("Project Stage")) {
      if (Projectstageandstatusdisplay) {
        const targetNames1 = ["UNDER VERIFICATION", "VERIFIED"];
        const projectstatustargetNamesfilteredArray = this.state.staticfilterdata.projectStage.values.filter(
          item => {
            return targetNames1.includes(item.displayName);
          }
        );
        this.setState({
          projectStageFilterdata: projectstatustargetNamesfilteredArray,
          selectalltext: true
        });
      } else {
        this.setState({
          projectStageFilterdata: this.state.staticfilterdata.projectStage
            .values,
          selectalltext: true
        });
      }
    } else if (
      this.state.quickfilterdata.includes("Project Sponsoring Ministry")
    ) {
      this.setState({
        sponsoringMinistryFilterdata: this.state.staticfilterdata
          .sponsoringMinistry.values,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Location")) {
      this.setState({
        projectLocationFilterdata: this.state.staticfilterdata.projectLocation
          .values,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Implementation Mode")) {
      this.setState({
        projectImplementationModeFilterdata: this.state.staticfilterdata
          .projectImplementationMode.values,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Zone")) {
      this.setState({
        projectZonefilterdata: this.state.staticfilterdata.projectZones.values,
        selectalltext: true
      });
    } else {
    }
    var newArr = searchedFilterList.map(item => item.displayName);
    //  const targetNames = [
    //   "UNDER CONSTRUCTION",
    //   "PROVISIONALLY COMMISSIONED",
    //   "PHYSICALLY COMPLETED/CC UNDER ISSUE",
    //   "NOT COMMISSIONED"
    // ]
    // const projectstatustargetNamesfilteredArray =  newArr.filter(item => {
    //   return targetNames.includes(item);
    // });
    const targetNames1 = ["UNDER VERIFICATION", "VERIFIED"];
    const projectstagefilteredArray = newArr.filter(item => {
      return targetNames1.includes(item);
    });
    // if(Projectstageandstatusdisplay &&(projectstatustargetNamesfilteredArray.length==this.state.ProjectStatus.length && displayname=="Project Status")){
    //   this.setState({selectall:true})
    //  }
    if (
      this.state.ProjectStatus.length >= 7 &&
      displayname == "Project Status"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.MonitoringFlag.length == newArr.length &&
      displayname == "Monitoring Flag"
    ) {
      this.setState({ selectall: true });
    } else if (
      (this.state.ProjectStage.length == newArr.length &&
        displayname == "Project Stage") ||
      (Projectstageandstatusdisplay &&
        (this.state.ProjectStage.length == projectstagefilteredArray.length &&
          displayname == "Project Stage"))
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.ProjectSponsoringMinistry.length == newArr.length &&
      displayname == "Project Sponsoring Ministry"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.ProjectLocation.length == newArr.length &&
      displayname == "Project Location"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.ImplementationMode.length == newArr.length &&
      displayname == "Implementation Mode"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.ProjectZone.length == newArr.length &&
      displayname == "Zone"
    ) {
      this.setState({ selectall: true });
    } else {
      this.setState({ selectall: false });
    }
  };
  getStateFilterVal = _filterName => {
    const {
      projectSponsoringMinistry,
      projectSector,
      recipientMinistryState,
      recipientState,
      issueSponsoringMinistry,
      recipientMinistry,
      recipientStateDepartment,
      guests,
      projectProponent,
      proponent,
      milestone,
      sponsoringDepartment,
      projectTags,
      projectStatus,
      projectLocation,
      centerState,
      projectFlags,
      projectstage,
      impmode
    } = this.state;
    switch (_filterName) {
      case "projectSponsoringMinistry":
        return projectSponsoringMinistry;
      case "projectFlags":
        return projectFlags;
      case "projectstage":
        return projectstage;
      case "impmode":
        return impmode;
      case "projectSector":
        return projectSector;
      case "recipientMinistryState":
        return recipientMinistryState;
      case "recipientState":
        return recipientState;
      case "issueSponsoringMinistry":
        return issueSponsoringMinistry;
      case "recipientMinistry":
        return recipientMinistry;
      case "recipientStateDepartment":
        return recipientStateDepartment;
      case "guests":
        return guests;
      case "projectProponent":
        return projectProponent;
      case "proponent":
        return proponent;
      case "milestone":
        return milestone;
      case "sponsoringDepartment":
        return sponsoringDepartment;
      case "projectTags":
        return projectTags;
      case "projectStatus":
        return projectStatus;
      case "projectLocation":
        return projectLocation;
      case "centerState":
        return centerState;
      default:
        return "";
    }
  };

  placeCheckedFiltersOnTop(filterValues) {
    let sortedFilterValues = [];

    for (let i = 0; i < filterValues.length; i++) {
      if (filterValues[i].checked === false) {
        sortedFilterValues.push(filterValues[i]);
      } else {
        sortedFilterValues.unshift(filterValues[i]);
      }
    }
    return sortedFilterValues;
  }

  render() {
    //const { onChange } = this.props;
    const {
      filterData,
      clearAll,
      filtersValue,
      staticFilterData,
      checkedData,
      Projectstageandstatusdisplay
    } = this.props;

    const filtersKeysArr = Object.keys(staticFilterData || {});

    // const minLengthForSearch = 5;
    if (!filtersKeysArr.length) {
      return null;
    }
    const user = getLocalstorage("user");
    // if (
    //   get(user, "groupCategory") == "STATE" ||
    //   get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
    //   get(user, "groupCategory") == "CENTRAL"
    // ) {
    //   filterData.agendaStages = {};
    // }
    return (
      isValidArray(filtersKeysArr) && (
        <React.Fragment className="row">
          <OverlayTrigger
            trigger="hover"
            defaultShow={false}
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-checking`} className="quick_filter_tolltip">
                Quick Filters
              </Tooltip>
            }
          >
            <div className="filter-title">
              {staticFilterData.projectFlags.values.length == 0 ? null : (
                <>
                  <Image
                    src={QuickFilterIcon}
                    onClick={this.handleOpen}
                    alt="Filter Icon"
                    style={{ cursor: "pointer" }}
                  />
                </>
              )}
            </div>
          </OverlayTrigger>
          <Modal
            size="lg"
            show={this.state.model_open}
            onHide={this.handleClose}
            aria-labelledby="example-modal-sizes-title-lg"
            className="content-modal"
          >
            <div
              className="modal-box-shadow"
              style={{
                width: "107%",
                background: "white",
                marginLeft: "-3%",
                borderRadius: "0.3rem"
              }}
            >
              <Modal.Header
                closeButton
                className="header-modal"
                style={{ backgroundColor: "#E7EFFB" }}
              >
                <Modal.Title
                  id="example-modal-sizes-title-lg"
                  style={{
                    paddingLeft: "4%",
                    paddingTop: "1.5%",
                    paddingBottom: "1.5%"
                  }}
                >
                  Quick Filters
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{ padding: "0%" }}
                className="quick-filter-modal-body"
              >
                <div className="row">
                  <div className="col-md-4 quickfilterbox">
                    {isValidArray(filtersKeysArr)
                      ? filtersKeysArr.map(filterName => {
                          const currentFilter = staticFilterData[filterName];
                          if (currentFilter && currentFilter.values) {
                            currentFilter.values = this.placeCheckedFiltersOnTop(
                              currentFilter.values
                            );
                          }
                          const filterCurrentValue = filtersValue[filterName];
                          const _filterName =
                            filterNames[get(currentFilter, "displayName")];
                          let searchedFilterList = this.getSearchedFilters(
                            get(currentFilter, "values"),
                            this.getStateFilterVal(_filterName)
                          );

                          // const searchResult = sortedListingArr[filterName];
                          if (!isValidArray(get(currentFilter, "values"))) {
                            return null;
                          }
                          let usersWithoutTim = searchedFilterList.filter(
                            user =>
                              user.key !== "NO_COMPLETION_STAGE" &&
                              user.key !== "NO_IMPLEMENTATION"
                          );
                          //console.log(usersWithoutTim)
                          return (
                            <div
                              key={filterName}
                              style={{
                                display:
                                  get(currentFilter, "displayName", "NA") ==
                                    "Monitoring Flag" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Status" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Stage" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Sponsoring Ministry" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Zone" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Location" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Implementation Mode"
                                    ? null
                                    : "none",
                                marginBottom: "0rem",
                                backgroundColor: this.state.quickfilterdata.includes(
                                  get(currentFilter, "displayName", "NA")
                                )
                                  ? "white"
                                  : "#F4F8FC",
                                borderBottom:
                                  get(currentFilter, "displayName", "NA") ==
                                  "Implementation Mode"
                                    ? "none"
                                    : "1.5px solid rgb(210, 210, 210)",
                                padding:
                                  get(currentFilter, "displayName") ==
                                  "Project Sponsoring Ministry"
                                    ? "6%"
                                    : "9%"
                              }}
                              className="quick-filter-text-project"
                              onClick={e =>
                                this.handleFiltertext(
                                  e,
                                  currentFilter.displayName,
                                  searchedFilterList,
                                  get(currentFilter, "values")
                                )
                              }
                            >
                              <div
                                data-test={get(
                                  currentFilter,
                                  "displayName",
                                  "NA"
                                ).replace(" ", "-")}
                                style={{
                                  marginLeft:
                                    get(currentFilter, "displayName") ==
                                    "Project Sponsoring Ministry"
                                      ? "9%"
                                      : "6%"
                                }}
                              >
                                {get(currentFilter, "displayName", "NA")}
                                &nbsp;
                                {get(currentFilter, "displayName", "NA") ==
                                  "Monitoring Flag" &&
                                this.state.MonitoringFlag.length != 0 ? (
                                  <>({this.state.MonitoringFlag.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Project Status" &&
                                this.state.ProjectStatus.length != 0 ? (
                                  <>({this.state.ProjectStatus.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Project Stage" &&
                                this.state.ProjectStage.length != 0 ? (
                                  <>({this.state.ProjectStage.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Project Sponsoring Ministry" &&
                                this.state.ProjectSponsoringMinistry.length !=
                                  0 ? (
                                  <>
                                    (
                                    {
                                      this.state.ProjectSponsoringMinistry
                                        .length
                                    }
                                    )
                                  </>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Project Location" &&
                                this.state.ProjectLocation.length != 0 ? (
                                  <>({this.state.ProjectLocation.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Implementation Mode" &&
                                this.state.ImplementationMode.length != 0 ? (
                                  <>({this.state.ImplementationMode.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Zone" &&
                                this.state.ProjectZone.length != 0 ? (
                                  <>({this.state.ProjectZone.length})</>
                                ) : null}
                              </div>
                            </div>
                          );
                        })
                      : null}
                  </div>
                  <div
                    className="col-md-8"
                    style={{ marginLeft: "-2%", paddingTop: "2%" }}
                  >
                    {isValidArray(filtersKeysArr)
                      ? filtersKeysArr.map(filterName => {
                          const currentFilter = staticFilterData[filterName];
                          if (currentFilter && currentFilter.values) {
                            currentFilter.values = this.placeCheckedFiltersOnTop(
                              currentFilter.values
                            );
                          }
                          const filterCurrentValue = filtersValue[filterName];
                          const _filterName =
                            filterNames[get(currentFilter, "displayName")];
                          let searchedFilterList = this.getSearchedFilters(
                            get(currentFilter, "values"),
                            this.getStateFilterVal(_filterName)
                          );

                          // const searchResult = sortedListingArr[filterName];
                          if (!isValidArray(get(currentFilter, "values"))) {
                            return null;
                          }
                          searchedFilterList.filter(
                            user => user.key !== "NO_COMPLETION_STAGE"
                            // &&
                            //   user.key !== "NO_IMPLEMENTATION"
                          );
                          //console.log(usersWithoutTim)
                          return (
                            <div
                              key={filterName}
                              style={{
                                display:
                                  get(currentFilter, "displayName", "NA") ==
                                    "Monitoring Flag" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Status" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Stage" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Sponsoring Ministry" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Zone" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Location" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Implementation Mode"
                                    ? null
                                    : "none",
                                marginBottom: "0rem"
                              }}
                            >
                              <div
                                style={{
                                  display:
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Monitoring Flag" &&
                                      this.state.quickfilterdata.includes(
                                        "Monitoring Flag"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Project Status" &&
                                      this.state.quickfilterdata.includes(
                                        "Project Status"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Project Stage" &&
                                      this.state.quickfilterdata.includes(
                                        "Project Stage"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Project Sponsoring Ministry" &&
                                      this.state.quickfilterdata.includes(
                                        "Project Sponsoring Ministry"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Zone" &&
                                      this.state.quickfilterdata.includes(
                                        "Zone"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Project Location" &&
                                      this.state.quickfilterdata.includes(
                                        "Project Location"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Implementation Mode" &&
                                      this.state.quickfilterdata.includes(
                                        "Implementation Mode"
                                      ))
                                      ? null
                                      : "none",
                                  marginBottom: "0rem"
                                }}
                              >
                                <div className="search-container-component-new">
                                  <Form.Control
                                    placeholder="Search"
                                    type="text"
                                    className="search-field"
                                    onChange={e =>
                                      this.searchDocument(
                                        e,
                                        currentFilter.displayName,
                                        searchedFilterList
                                      )
                                    }
                                    value={this.state.searchedtext}
                                  />
                                  <span
                                    style={{
                                      marginLeft: "-6%",
                                      cursor: "pointer",
                                      display:
                                        this.state.searchedtext == ""
                                          ? "none"
                                          : null
                                    }}
                                  >
                                    <img
                                      src={CrossIcon}
                                      alt="Clear search"
                                      onClick={() =>
                                        this.handleCross(searchedFilterList)
                                      }
                                    />
                                  </span>
                                  {<span className="search-container-icon" />}
                                </div>
                                {/** <QuickFilterSearch
                        placeholder="Search"
                        keyName="searchText"
                        onChange={e =>
                          this.searchDocument(e, currentFilter.displayName,searchedFilterList)
                        }
                        searchedtext={this.state.searchedtext}
                       
                      /> */}

                                <div
                                  className="row"
                                  style={{
                                    padding: "1.5%",
                                    marginLeft: "1.18%"
                                  }}
                                >
                                  <div className="col-12">
                                    <div
                                      style={{
                                        display:
                                          this.state.selectalltext == false
                                            ? "none"
                                            : null
                                      }}
                                    >
                                      <label class="container1">
                                        <input
                                          type="checkbox"
                                          id={get(currentFilter, "displayName")}
                                          checked={
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.MonitoringFlag
                                                  .length ||
                                                this.state
                                                  .projectFlagsFilterdata
                                                  .length ==
                                                  this.state.MonitoringFlag
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.ProjectStatus
                                                  .length ||
                                                this.state.projectTagsFilterdata
                                                  .length ==
                                                  this.state.ProjectStatus
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.ProjectStage
                                                  .length ||
                                                this.state
                                                  .projectStageFilterdata
                                                  .length ==
                                                  this.state.ProjectStage
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.ProjectLocation
                                                  .length ||
                                                this.state
                                                  .projectLocationFilterdata
                                                  .length ==
                                                  this.state.ProjectLocation
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state
                                                  .ProjectSponsoringMinistry
                                                  .length ||
                                                this.state
                                                  .sponsoringMinistryFilterdata
                                                  .length ==
                                                  this.state
                                                    .ProjectSponsoringMinistry
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.ImplementationMode
                                                  .length ||
                                                this.state
                                                  .projectImplementationModeFilterdata
                                                  .length ==
                                                  this.state.ImplementationMode
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.ProjectZone.length ||
                                                this.state.projectZonefilterdata
                                                  .length ==
                                                  this.state.ProjectZone
                                                    .length))
                                          }
                                          onChange={e =>
                                            this.handleSelectAll(
                                              e,
                                              searchedFilterList,
                                              get(currentFilter, "displayName")
                                            )
                                          }
                                        />
                                        <span class="checkmark1" />
                                      </label>

                                      <label
                                        className="quickfilterselectalltxt"
                                        for={get(currentFilter, "displayName")}
                                      >
                                        Select All
                                      </label>
                                    </div>
                                    <div
                                      style={{
                                        height: "21.5em",
                                        overflowX: "hidden"
                                      }}
                                    >
                                      {this.state.quickfilterdata.includes(
                                        "Monitoring Flag"
                                      ) ? (
                                        <>
                                          {this.state.projectFlagsFilterdata.map(
                                            filter => (
                                              <div
                                                className="row"
                                                style={{
                                                  marginBottom:
                                                    filter.displayName.length >
                                                      50 ==
                                                    true
                                                      ? "5%"
                                                      : "3%",
                                                  marginTop: "2%"
                                                }}
                                              >
                                                <div className="col-12">
                                                  <label class="container1">
                                                    <input
                                                      type="checkbox"
                                                      id={filter.key}
                                                      checked={
                                                        this.state.StaticCheckboxData.includes(
                                                          filter.displayName
                                                        ) ||
                                                        this.state.propsCheckedData.includes(
                                                          filter.displayName
                                                        )
                                                      }
                                                      onChange={e =>
                                                        this.handlecheckboxcount(
                                                          e,
                                                          this.state.quickfilterdata.toString(),
                                                          filter,
                                                          searchedFilterList
                                                        )
                                                      }
                                                    />

                                                    <span class="checkmark1" />
                                                  </label>

                                                  <label
                                                    style={{
                                                      width:
                                                        filter.displayName
                                                          .length <=
                                                          20 ==
                                                          true &&
                                                        filter.displayName !=
                                                          "PHYSICALLY_COMPLETED"
                                                          ? "auto"
                                                          : null,
                                                      fontSize: "14px",
                                                      marginLeft: "5%",
                                                      position: "absolute",
                                                      cursor: "pointer",
                                                      fontFamily: "mpsb",
                                                      color: "#3c495a",
                                                      marginTop:
                                                        filter.displayName
                                                          .length >
                                                          50 ==
                                                        true
                                                          ? null
                                                          : "0.5%"
                                                    }}
                                                    for={filter.key}
                                                  >
                                                    {filter.displayName ==
                                                    "PHYSICALLY_COMPLETED" ? (
                                                      <>
                                                        PHYSICALLY COMPLETED/CC
                                                        UNDER ISSUE
                                                      </>
                                                    ) : (
                                                      <>{filter.displayName}</>
                                                    )}
                                                    &nbsp;({filter.count})
                                                  </label>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Project Status"
                                      ) ? (
                                        <>
                                          {this.state.projectTagsFilterdata.map(
                                            filter => (
                                              <>
                                                {Projectstageandstatusdisplay ? (
                                                  <>
                                                    <div
                                                      className="row"
                                                      style={{
                                                        marginBottom:
                                                          filter.displayName
                                                            .length >
                                                            50 ==
                                                          true
                                                            ? "5%"
                                                            : "3%",
                                                        marginTop: "2%",
                                                        display:
                                                          // filter.displayName ==
                                                          //   "NO_IMPLEMENTATION"
                                                          //  ||
                                                          filter.displayName ==
                                                          "NO_COMPLETION_STAGE"
                                                            ? "none"
                                                            : null
                                                      }}
                                                    >
                                                      <div className="col-12">
                                                        <label class="container1">
                                                          <input
                                                            type="checkbox"
                                                            id={filter.key}
                                                            checked={
                                                              this.state.StaticCheckboxData.includes(
                                                                filter.displayName
                                                              ) ||
                                                              this.state.propsCheckedData.includes(
                                                                filter.displayName
                                                              )
                                                            }
                                                            onChange={e =>
                                                              this.handlecheckboxcount(
                                                                e,
                                                                this.state.quickfilterdata.toString(),
                                                                filter,
                                                                searchedFilterList
                                                              )
                                                            }
                                                          />

                                                          <span class="checkmark1" />
                                                        </label>

                                                        <label
                                                          style={{
                                                            width:
                                                              filter.displayName
                                                                .length <=
                                                                20 ==
                                                                true &&
                                                              filter.displayName !=
                                                                "PHYSICALLY_COMPLETED"
                                                                ? "auto"
                                                                : null,
                                                            fontSize: "14px",
                                                            marginLeft: "5%",
                                                            position:
                                                              "absolute",
                                                            cursor: "pointer",
                                                            fontFamily: "mpsb",
                                                            color: "#3c495a",
                                                            marginTop:
                                                              filter.displayName
                                                                .length >
                                                                50 ==
                                                              true
                                                                ? null
                                                                : "0.5%"
                                                          }}
                                                          for={filter.key}
                                                        >
                                                          {filter.displayName ==
                                                          "PHYSICALLY_COMPLETED" ? (
                                                            <>
                                                              PHYSICALLY
                                                              COMPLETED/CC UNDER
                                                              ISSUE
                                                            </>
                                                          ) : (
                                                            <>
                                                              {
                                                                filter.displayName
                                                              }
                                                            </>
                                                          )}
                                                          &nbsp;({filter.count})
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <>
                                                    <div
                                                      className="row"
                                                      style={{
                                                        marginBottom:
                                                          filter.displayName
                                                            .length >
                                                            50 ==
                                                          true
                                                            ? "5%"
                                                            : "3%",
                                                        marginTop: "2%",
                                                        display:
                                                          filter.displayName ==
                                                          "NO_COMPLETION_STAGE"
                                                            ? //   ||
                                                              // filter.displayName ==
                                                              //   "NO_IMPLEMENTATION"
                                                              "none"
                                                            : null
                                                      }}
                                                    >
                                                      <div className="col-12">
                                                        <label class="container1">
                                                          <input
                                                            type="checkbox"
                                                            id={filter.key}
                                                            checked={
                                                              this.state.StaticCheckboxData.includes(
                                                                filter.displayName
                                                              ) ||
                                                              this.state.propsCheckedData.includes(
                                                                filter.displayName
                                                              )
                                                            }
                                                            onChange={e =>
                                                              this.handlecheckboxcount(
                                                                e,
                                                                this.state.quickfilterdata.toString(),
                                                                filter,
                                                                searchedFilterList
                                                              )
                                                            }
                                                          />

                                                          <span class="checkmark1" />
                                                        </label>

                                                        <label
                                                          style={{
                                                            width:
                                                              filter.displayName
                                                                .length <=
                                                                20 ==
                                                                true &&
                                                              filter.displayName !=
                                                                "PHYSICALLY_COMPLETED"
                                                                ? "auto"
                                                                : null,
                                                            fontSize: "14px",
                                                            marginLeft: "5%",
                                                            position:
                                                              "absolute",
                                                            cursor: "pointer",
                                                            fontFamily: "mpsb",
                                                            color: "#3c495a",
                                                            marginTop:
                                                              filter.displayName
                                                                .length >
                                                                50 ==
                                                              true
                                                                ? null
                                                                : "0.5%"
                                                          }}
                                                          for={filter.key}
                                                        >
                                                          {filter.displayName ==
                                                          "PHYSICALLY_COMPLETED" ? (
                                                            <>
                                                              PHYSICALLY
                                                              COMPLETED/CC UNDER
                                                              ISSUE
                                                            </>
                                                          ) : (
                                                            <>
                                                              {
                                                                filter.displayName
                                                              }
                                                            </>
                                                          )}
                                                          &nbsp;({filter.count})
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </>
                                                )}
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Project Stage"
                                      ) ? (
                                        <>
                                          {this.state.projectStageFilterdata.map(
                                            filter => (
                                              <>
                                                {Projectstageandstatusdisplay ? (
                                                  <>
                                                    <div
                                                      className="row"
                                                      style={{
                                                        marginBottom:
                                                          filter.displayName
                                                            .length >
                                                            50 ==
                                                          true
                                                            ? "5%"
                                                            : "3%",
                                                        marginTop: "2%",
                                                        display:
                                                          filter.displayName ==
                                                            "UNDER VERIFICATION" ||
                                                          filter.displayName ==
                                                            "VERIFIED"
                                                            ? null
                                                            : "none"
                                                      }}
                                                    >
                                                      <div className="col-12">
                                                        <label class="container1">
                                                          <input
                                                            type="checkbox"
                                                            id={filter.key}
                                                            checked={
                                                              this.state.StaticCheckboxData.includes(
                                                                filter.displayName
                                                              ) ||
                                                              this.state.propsCheckedData.includes(
                                                                filter.displayName
                                                              )
                                                            }
                                                            onChange={e =>
                                                              this.handlecheckboxcount(
                                                                e,
                                                                this.state.quickfilterdata.toString(),
                                                                filter,
                                                                searchedFilterList
                                                              )
                                                            }
                                                          />

                                                          <span class="checkmark1" />
                                                        </label>

                                                        <label
                                                          style={{
                                                            width:
                                                              filter.displayName
                                                                .length <=
                                                                20 ==
                                                                true &&
                                                              filter.displayName !=
                                                                "PHYSICALLY_COMPLETED"
                                                                ? "auto"
                                                                : null,
                                                            fontSize: "14px",
                                                            marginLeft: "5%",
                                                            position:
                                                              "absolute",
                                                            cursor: "pointer",
                                                            fontFamily: "mpsb",
                                                            color: "#3c495a",
                                                            marginTop:
                                                              filter.displayName
                                                                .length >
                                                                50 ==
                                                              true
                                                                ? null
                                                                : "0.5%"
                                                          }}
                                                          for={filter.key}
                                                        >
                                                          {filter.displayName ==
                                                          "PHYSICALLY_COMPLETED" ? (
                                                            <>
                                                              PHYSICALLY
                                                              COMPLETED/CC UNDER
                                                              ISSUE
                                                            </>
                                                          ) : (
                                                            <>
                                                              {
                                                                filter.displayName
                                                              }
                                                            </>
                                                          )}
                                                          &nbsp;({filter.count})
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <>
                                                    <div
                                                      className="row"
                                                      style={{
                                                        marginBottom:
                                                          filter.displayName
                                                            .length >
                                                            50 ==
                                                          true
                                                            ? "5%"
                                                            : "3%",
                                                        marginTop: "2%",
                                                        display:
                                                          filter.displayName ==
                                                          "NO_COMPLETION_STAGE"
                                                            ? //   ||
                                                              // filter.displayName ==
                                                              //   "NO_IMPLEMENTATION"
                                                              "none"
                                                            : null
                                                      }}
                                                    >
                                                      <div className="col-12">
                                                        <label class="container1">
                                                          <input
                                                            type="checkbox"
                                                            id={filter.key}
                                                            checked={
                                                              this.state.StaticCheckboxData.includes(
                                                                filter.displayName
                                                              ) ||
                                                              this.state.propsCheckedData.includes(
                                                                filter.displayName
                                                              )
                                                            }
                                                            onChange={e =>
                                                              this.handlecheckboxcount(
                                                                e,
                                                                this.state.quickfilterdata.toString(),
                                                                filter,
                                                                searchedFilterList
                                                              )
                                                            }
                                                          />

                                                          <span class="checkmark1" />
                                                        </label>

                                                        <label
                                                          style={{
                                                            width:
                                                              filter.displayName
                                                                .length <=
                                                                20 ==
                                                                true &&
                                                              filter.displayName !=
                                                                "PHYSICALLY_COMPLETED"
                                                                ? "auto"
                                                                : null,
                                                            fontSize: "14px",
                                                            marginLeft: "5%",
                                                            position:
                                                              "absolute",
                                                            cursor: "pointer",
                                                            fontFamily: "mpsb",
                                                            color: "#3c495a",
                                                            marginTop:
                                                              filter.displayName
                                                                .length >
                                                                50 ==
                                                              true
                                                                ? null
                                                                : "0.5%"
                                                          }}
                                                          for={filter.key}
                                                        >
                                                          {filter.displayName ==
                                                          "PHYSICALLY_COMPLETED" ? (
                                                            <>
                                                              PHYSICALLY
                                                              COMPLETED/CC UNDER
                                                              ISSUE
                                                            </>
                                                          ) : (
                                                            <>
                                                              {
                                                                filter.displayName
                                                              }
                                                            </>
                                                          )}
                                                          &nbsp;({filter.count})
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </>
                                                )}
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : null}

                                      {this.state.quickfilterdata.includes(
                                        "Project Sponsoring Ministry"
                                      ) ? (
                                        <>
                                          {this.state.sponsoringMinistryFilterdata.map(
                                            filter => (
                                              <div
                                                className="row"
                                                style={{
                                                  marginBottom:
                                                    filter.displayName.length >
                                                      50 ==
                                                    true
                                                      ? "5%"
                                                      : "3%",
                                                  marginTop: "2%",
                                                  display:
                                                    filter.displayName ==
                                                    "NO_COMPLETION_STAGE"
                                                      ? //   ||
                                                        // filter.displayName ==
                                                        //   "NO_IMPLEMENTATION"
                                                        "none"
                                                      : null
                                                }}
                                              >
                                                <div className="col-12">
                                                  <label class="container1">
                                                    <input
                                                      type="checkbox"
                                                      id={filter.key}
                                                      checked={
                                                        this.state.StaticCheckboxData.includes(
                                                          filter.displayName
                                                        ) ||
                                                        this.state.propsCheckedData.includes(
                                                          filter.displayName
                                                        )
                                                      }
                                                      onChange={e =>
                                                        this.handlecheckboxcount(
                                                          e,
                                                          this.state.quickfilterdata.toString(),
                                                          filter,
                                                          searchedFilterList
                                                        )
                                                      }
                                                    />

                                                    <span class="checkmark1" />
                                                  </label>

                                                  <label
                                                    style={{
                                                      width:
                                                        filter.displayName
                                                          .length <=
                                                          20 ==
                                                          true &&
                                                        filter.displayName !=
                                                          "PHYSICALLY_COMPLETED"
                                                          ? "auto"
                                                          : null,
                                                      fontSize: "14px",
                                                      marginLeft: "5%",
                                                      position: "absolute",
                                                      cursor: "pointer",
                                                      fontFamily: "mpsb",
                                                      color: "#3c495a",
                                                      marginTop:
                                                        filter.displayName
                                                          .length >
                                                          50 ==
                                                        true
                                                          ? null
                                                          : "0.5%"
                                                    }}
                                                    for={filter.key}
                                                  >
                                                    {filter.displayName ==
                                                    "PHYSICALLY_COMPLETED" ? (
                                                      <>
                                                        PHYSICALLY COMPLETED/CC
                                                        UNDER ISSUE
                                                      </>
                                                    ) : (
                                                      <>{filter.displayName}</>
                                                    )}
                                                    &nbsp;({filter.count})
                                                  </label>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Zone"
                                      ) ? (
                                        <>
                                          {this.state.projectZonefilterdata.map(
                                            filter => (
                                              <div
                                                className="row"
                                                style={{
                                                  marginBottom:
                                                    filter.displayName.length >
                                                      50 ==
                                                    true
                                                      ? "5%"
                                                      : "3%",
                                                  marginTop: "2%",
                                                  display:
                                                    filter.displayName ==
                                                    "NO_COMPLETION_STAGE"
                                                      ? //    ||
                                                        // filter.displayName ==
                                                        //   "NO_IMPLEMENTATION"
                                                        "none"
                                                      : null
                                                }}
                                              >
                                                <div className="col-12">
                                                  <label class="container1">
                                                    <input
                                                      type="checkbox"
                                                      id={filter.key}
                                                      checked={
                                                        this.state.StaticCheckboxData.includes(
                                                          filter.displayName
                                                        ) ||
                                                        this.state.propsCheckedData.includes(
                                                          filter.displayName
                                                        )
                                                      }
                                                      onChange={e =>
                                                        this.handlecheckboxcount(
                                                          e,
                                                          this.state.quickfilterdata.toString(),
                                                          filter,
                                                          searchedFilterList
                                                        )
                                                      }
                                                    />

                                                    <span class="checkmark1" />
                                                  </label>

                                                  <label
                                                    style={{
                                                      width:
                                                        filter.displayName
                                                          .length <=
                                                          20 ==
                                                          true &&
                                                        filter.displayName !=
                                                          "PHYSICALLY_COMPLETED"
                                                          ? "auto"
                                                          : null,
                                                      fontSize: "14px",
                                                      marginLeft: "5%",
                                                      position: "absolute",
                                                      cursor: "pointer",
                                                      fontFamily: "mpsb",
                                                      color: "#3c495a",
                                                      marginTop:
                                                        filter.displayName
                                                          .length >
                                                          50 ==
                                                        true
                                                          ? null
                                                          : "0.5%"
                                                    }}
                                                    for={filter.key}
                                                  >
                                                    {filter.displayName ==
                                                    "PHYSICALLY_COMPLETED" ? (
                                                      <>
                                                        PHYSICALLY COMPLETED/CC
                                                        UNDER ISSUE
                                                      </>
                                                    ) : (
                                                      <>{filter.displayName}</>
                                                    )}
                                                    &nbsp;({filter.count})
                                                  </label>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Project Location"
                                      ) ? (
                                        <>
                                          {this.state.projectLocationFilterdata.map(
                                            filter => (
                                              <div
                                                className="row"
                                                style={{
                                                  marginBottom:
                                                    filter.displayName.length >
                                                      50 ==
                                                    true
                                                      ? "5%"
                                                      : "3%",
                                                  marginTop: "2%",
                                                  display:
                                                    filter.displayName ==
                                                    "NO_COMPLETION_STAGE"
                                                      ? //   ||
                                                        // filter.displayName ==
                                                        //   "NO_IMPLEMENTATION"
                                                        "none"
                                                      : null
                                                }}
                                              >
                                                <div className="col-12">
                                                  <label class="container1">
                                                    <input
                                                      type="checkbox"
                                                      id={filter.key}
                                                      checked={
                                                        this.state.StaticCheckboxData.includes(
                                                          filter.displayName
                                                        ) ||
                                                        this.state.propsCheckedData.includes(
                                                          filter.displayName
                                                        )
                                                      }
                                                      onChange={e =>
                                                        this.handlecheckboxcount(
                                                          e,
                                                          this.state.quickfilterdata.toString(),
                                                          filter,
                                                          searchedFilterList
                                                        )
                                                      }
                                                    />

                                                    <span class="checkmark1" />
                                                  </label>

                                                  <label
                                                    style={{
                                                      width:
                                                        filter.displayName
                                                          .length <=
                                                          20 ==
                                                          true &&
                                                        filter.displayName !=
                                                          "PHYSICALLY_COMPLETED"
                                                          ? "auto"
                                                          : null,
                                                      fontSize: "14px",
                                                      marginLeft: "5%",
                                                      position: "absolute",
                                                      cursor: "pointer",
                                                      fontFamily: "mpsb",
                                                      color: "#3c495a",
                                                      marginTop:
                                                        filter.displayName
                                                          .length >
                                                          50 ==
                                                        true
                                                          ? null
                                                          : "0.5%"
                                                    }}
                                                    for={filter.key}
                                                  >
                                                    {filter.displayName ==
                                                    "PHYSICALLY_COMPLETED" ? (
                                                      <>
                                                        PHYSICALLY COMPLETED/CC
                                                        UNDER ISSUE
                                                      </>
                                                    ) : (
                                                      <>{filter.displayName}</>
                                                    )}
                                                    &nbsp;({filter.count})
                                                  </label>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Implementation Mode"
                                      ) ? (
                                        <>
                                          {this.state.projectImplementationModeFilterdata.map(
                                            filter => (
                                              <div
                                                className="row"
                                                style={{
                                                  marginBottom:
                                                    filter.displayName.length >
                                                      50 ==
                                                    true
                                                      ? "5%"
                                                      : "3%",
                                                  marginTop: "2%",
                                                  display:
                                                    filter.displayName ==
                                                    "NO_COMPLETION_STAGE"
                                                      ? //    ||
                                                        // filter.displayName ==
                                                        //   "NO_IMPLEMENTATION"
                                                        "none"
                                                      : null
                                                }}
                                              >
                                                <div className="col-12">
                                                  <label class="container1">
                                                    <input
                                                      type="checkbox"
                                                      id={filter.key}
                                                      checked={
                                                        this.state.StaticCheckboxData.includes(
                                                          filter.displayName
                                                        ) ||
                                                        this.state.propsCheckedData.includes(
                                                          filter.displayName
                                                        )
                                                      }
                                                      onChange={e =>
                                                        this.handlecheckboxcount(
                                                          e,
                                                          this.state.quickfilterdata.toString(),
                                                          filter,
                                                          searchedFilterList
                                                        )
                                                      }
                                                    />

                                                    <span class="checkmark1" />
                                                  </label>

                                                  <label
                                                    style={{
                                                      width:
                                                        filter.displayName
                                                          .length <=
                                                          20 ==
                                                          true &&
                                                        filter.displayName !=
                                                          "PHYSICALLY_COMPLETED"
                                                          ? "auto"
                                                          : null,
                                                      fontSize: "14px",
                                                      marginLeft: "5%",
                                                      position: "absolute",
                                                      cursor: "pointer",
                                                      fontFamily: "mpsb",
                                                      color: "#3c495a",
                                                      marginTop:
                                                        filter.displayName
                                                          .length >
                                                          50 ==
                                                        true
                                                          ? null
                                                          : "0.5%"
                                                    }}
                                                    for={filter.key}
                                                  >
                                                    {filter.displayName ==
                                                    "PHYSICALLY_COMPLETED" ? (
                                                      <>
                                                        PHYSICALLY COMPLETED/CC
                                                        UNDER ISSUE
                                                      </>
                                                    ) : (
                                                      <>{filter.displayName}</>
                                                    )}
                                                    &nbsp;({filter.count})
                                                  </label>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : null}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer
                style={{ borderTop: "1px solid white", marginTop: "-3%" }}
              >
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => {
                    this.setState({
                      MonitoringFlag: [],
                      ProjectStatus: [],
                      ProjectStage: [],
                      ProjectSponsoringMinistry: [],
                      ProjectLocation: [],
                      ProjectZone: [],
                      ImplementationMode: [],
                      selectall: false,
                      StaticCheckboxData: [],
                      propsCheckedData: []
                    });
                  }}
                  className="btn-grey quick-filter-button shadow-none"
                  style={{ marginRight: "8px", paddingLeft: "6%" }}
                >
                  Clear All
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={e => {
                    this.handleSubmit();
                  }}
                  className="btn-orange quick-filter-button"
                  style={{ marginLeft: "8px" }}
                >
                  Apply
                </Button>
              </Modal.Footer>
            </div>
          </Modal>
        </React.Fragment>
      )
    );
  }
}

ProjectQuickFilter.propTypes = {
  filterData: PropTypes.array,
  callApiOnSuccess: PropTypes.func
};

ProjectQuickFilter.defaultProps = {
  filterData: [],
  callApiOnSuccess: () => {}
};

export default ProjectQuickFilter;
